// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1023px","white":"#ffffff","whiteSmoke":"#f5f5f5","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#000000","grey":"#9e9e9e","lightGrey":"#cccccc","primary":"#0a747b","secondary":"#99cc00","tertiary":"#006675","error":"#ff0000","success":"#99cc00","inactive":"#cccccc"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/_variables.scss
// module id = 530
// module chunks = 0